import { ClickHouseQueryDetail } from "../../services/langfuseQueries";

export const STATUS_OPTIONS = [
  { value: "success", label: "Success" },
  { value: "error", label: "Error" },
  { value: "empty", label: "Empty Result" },
];

export const getDefaultDates = () => {
  const end = new Date();
  const start = new Date();
  start.setDate(start.getDate() - 7);
  return {
    start: start.toISOString().split("T")[0],
    end: end.toISOString().split("T")[0],
  };
};

export const PAGE_SIZE = 100;

export const formatDuration = (ms: number | null | undefined): string => {
  if (ms === null || ms === undefined) return "-";
  if (ms < 1000) return `${Math.round(ms)}ms`;
  return `${(ms / 1000).toFixed(2)}s`;
};

export const formatDate = (dateStr: string): string => {
  const date = new Date(dateStr);
  return date.toLocaleString();
};

export const truncateQuery = (query: string, maxLength = 80): string => {
  const singleLine = query.replace(/\s+/g, " ").trim();
  if (singleLine.length <= maxLength) return singleLine;
  return singleLine.substring(0, maxLength) + "...";
};

export const parseResultPreview = (
  resultPreview: Array<Record<string, unknown>>
): { headers: string[]; rows: string[][] } | null => {
  if (!resultPreview || resultPreview.length === 0) return null;

  const first = resultPreview[0];
  if (Object.keys(first).length === 1 && "result" in first && typeof first.result === "string") {
    const csvString = first.result as string;
    const lines = csvString.trim().split("\n");
    if (lines.length === 0) return null;

    const headers = lines[0].split(",");
    const rows = lines.slice(1).map(line => line.split(","));
    return { headers, rows };
  }

  const headers = Object.keys(first);
  const rows = resultPreview.map(row =>
    headers.map(h => {
      const val = row[h];
      return typeof val === "object" ? JSON.stringify(val) : String(val ?? "-");
    })
  );
  return { headers, rows };
};

export const isEmptyResult = (query: ClickHouseQueryDetail): boolean => {
  if (!query.result_preview || query.result_preview.length === 0) return true;
  const resultContent = query.result_preview[0]?.result;
  if (!resultContent || typeof resultContent !== "string") return true;
  return resultContent.trim() === "";
};

export const getDisplayStatus = (query: ClickHouseQueryDetail): string => {
  if (query.status === "error" || query.error_message) return "error";
  if (query.status === "success" && isEmptyResult(query)) return "empty";
  return query.status;
};
